import {
  clearSession,
  IPublicSession,
  resetSession,
  sharedSessionSchema,
  updatePublicSession,
  userSession,
} from 'state/session';
import { State } from 'utils/state';
import { IntegrationType, integrationType } from 'utils/ui/app';

export function syncToServer(state: State<IPublicSession>) {
  state.on('change', (keys) => {
    const updateEverything =
      integrationType() === IntegrationType.WebComponent && userSession().get('activeExperience') === '2D';
    // Block syncing when offline (except for offline flag changes)
    if (userSession().get('offline') && !keys.includes('offline')) {
      console.warn('Session sync blocked: offline mode is enabled');
      return;
    }

    // do not proceed if session is starting or ending
    if (keys.includes('id') || keys.includes('endedAt')) {
      if (keys.includes('endedAt') && integrationType() === IntegrationType.WebComponent) {
        // Reset ended session for web component case (handled outside of wc context in standalone)
        clearSession();
        resetSession();
      }
      return;
    }

    if ((userSession().get('isShared') && keys.includes('brand')) || keys.includes('market')) {
      console.warn('Changes to brand or market while sharing are not allowed. Skipping session update.');
      return;
    }

    // only keys that are part of the internal session schema should trigger an update on database level
    // if none of those keys changed, we can skip the database update and just emit the event to the participants
    const relevantKeys = Object.keys(sharedSessionSchema.shape);
    if (!relevantKeys.some((key) => keys.includes(key))) {
      console.warn('No relevant keys changed for session update: ', keys);
      updatePublicSession({ emitOnly: true, updateEverything });
      return;
    }

    // send session data to the server
    updatePublicSession({ updateEverything });
  });
}
